import script from "./TypeSubOptions.vue?vue&type=script&setup=true&lang=js"
export * from "./TypeSubOptions.vue?vue&type=script&setup=true&lang=js"

import "./TypeSubOptions.vue?vue&type=style&index=0&id=1f9eeb14&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f9eeb14"]])

export default __exports__